<template>
    <section
        class="section error-404 h-100 d-flex flex-column align-items-center justify-content-center"
    >
        <h1>Oops!</h1>
        <div>The page you are looking for doesn't exist.</div>
        <a href="/" class="btn btn-primary mt-2" role="button">Back to home</a>
    </section>
</template>

<script setup lang="ts"></script>
